import React, {useEffect} from 'react';
import Nav from '../../Page Components/Nav';
import Footer from "../../Page Components/Footer";
import Card from "../../Co Components/SquareCards";
import Square from "../../Co Components/SquareCards";
import Title from "../../Co Components/Titles";
import homehero from '../../assets/Images/homehero.png';
import Rectangle from "../../Co Components/RectangleCards";
import LineButton from "../../Co Components/LineButton";
import hackerRed from '../../assets/Images/hacker copy.png';
import BlogCard from "../../Co Components/BlogCards";
import HomeCard from "../../Co Components/HomeCards";
import PrimaryButton from "../../Co Components/PrimaryButton";
import SecondaryButton from "../../Co Components/SecondaryButton";
const GRC = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });

    return (
        <>

            <Nav />
            <section className={' d-flex flex-row mt-0  align-items-center w-90 '}>
                <article>
                    <div className={'mx-5 w-75'}>
                        <h1 className={'bebas display-1 text-black bolde  line-normal'}>WhiteGuard
                            <span className={'bebas yellow'}><br /> GRC As A Service</span><br />
                            Services</h1>
                    </div>

                    <div className={'w-75 mx-5'}>
                        <p className={'bolder h6'} >
                        Governance, Risk and Compliance as a Service is new
offering designed carefully for our customers to reduce GRC operations
cost and build a mature GRC department that aligned with your business
strategy and objectives . GRC as a Service is a unique service that allows
our customers to leverage the benefits of our experienced and trained
GRC consultants that implement, enhance and manage your GRC
environment.
                        </p>
                    </div>
                </article>
                <figure className=' headerImage align-self-center d-flex flex-column w-25'>
                    <HomeCard className={'info'} />
                    <img src={hackerRed} className={'hackerImage z-1'} />
                </figure>

            </section>

            <Title className={'mt-6'} header={"the"} body={"Benefits"} />
            <div className={'d-flex mb-5 flex-row justify-content-center align-items-center flex-wrap'}>
                <Square className={'mx-4 cardYellow mt-5'} Title={"Stability"} text={' Establishing GRC gives resolution to immediate and long-term risk exposure while \n' +
                    'allowing for an agile and scalable control environment.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Optimization "} text={'Non-value adding activities are eliminated and value-adding activities are \n' +
                    'streamlined to reduce time and any undesirable variations. Replace \n' +
                    'manual preventative controls with automated detective controls, which \n' +
                    'increase efficiency and traceability.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Transparency "} text={'GRC allows the ability to view a more complete picture of the organization \n' +
                    'and processes, allowing owners to have access and control over necessary\n' +
                    ' content to understand the business unit profile and applicable risks \n' +
                    'and challenges.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Reduced Costs "} text={'Lower costs contribute to the overall ROI gains represented by effective GRC \n' +
                    'activities. There is also reduced costs in maintaining duplicated \n' +
                    'controls, tests, issues, actions, and reporting across multiple \n' +
                    'disciplines.'}/>

                <Square className={'mx-4 cardYellow mt-5'} Title={"Consistency "} text={' Improved alignment of objectives with mission, vision, and value of the \n' +
                    'organization, resulting in better decision-making agility and \n' +
                    'confidence.'} />
            </div>
            {/*<Title className={'mt-6'} header={"the"} body={"Process"} />*/}
            {/*<div className={'d-flex mb-12 flex-column align-items-center justify-content-start process-container'} style={{ transition: 'all 0.3s ease' }}>*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Goal Setting'} text={'Customer asks the red team to determine if a threat agent can access specific assets.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Reconnaissance'} text={'Red team identifies network services, web applications, and employee portals.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Penetration Testing Exercise'} text={'Network service exploitation:'*/}
            {/*         +' Exploiting unpatched or \n' +*/}
            {/*        'misconfigured network services.\n' +*/}
            {/*        '\n Application layer exploitation: Web applications are often\n' +*/}
            {/*        'the first thing an attacker sees when looking at an organization’s\n' +*/}
            {/*        'network perimeter.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Phishing Exercise'} text={'Email and phone-based social engineering. With a little \n' +*/}
            {/*        'bit of research on individuals or organizations, phishing emails become a lot more convincing. This low hanging fruit is frequently the first in a\n' +*/}
            {/*        ' chain of composite attacks that lead to the goal.'} />*/}
            {/*    <Rectangle className={'mt-4 cardRed'} Title={'Physical Exercise'} text={'Physical facility exploitation. People have a natural\n' +*/}
            {/*        'inclination to avoid confrontation. Thus, gaining access to a secure\n' +*/}
            {/*        'facility is often as easy as following someone through a door.'} />*/}
            {/*</div>*/}


            <Footer />
        </>
    );

}

export default GRC;